<form [formGroup]="form()">
  @let controls = form().controls;
  <onyx-form-group [controls]="controls.quantity" [gap]="8" errorsAlign="right">
    <div class="details">
      <p>
        @if (good().unit) {
          {{ (unitName$ | async) ?? '&nbsp;' }}
        } @else {
          {{ `${I18N}.emptyUnit` | translate }}
        }
      </p>

      <p class="available">
        {{ `${I18N}.availableQuantity` | translate }}
        {{ Math.max(availableQuantity(), 0) / 10 ** decimalPlaces() | number }}
        {{ unit() | translate }}
      </p>
    </div>

    <onyx-text-field
      [formControl]="controls.quantity"
      placeholder="labels.quantity"
      [decimalPlaces]="decimalPlaces()"
      [showClear]="false"
      [size]="32"
      [showErrors]="false"
    ></onyx-text-field>
  </onyx-form-group>

  <onyx-text-field
    [value]="unloadedWeight() ? (unloadedWeight() | number: '1.0-0') : '-'"
    [disabled]="true"
    unit="kg"
    [size]="32"
  ></onyx-text-field>
</form>
